export default __webpack_public_path__ + "static/media/TodayStories.834f3ed2.png";